import { Ng2StateDeclaration } from '@uirouter/angular';

import {DiagtoolOverviewComponent} from './components/diagtool-overview/diagtool-overview.component';

export const diagToolOverviewState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'diagtool',
    url: '/project/:projectId/admin/diagtool',
    component: DiagtoolOverviewComponent,
    params: {
        projectId: {squash: true, value: null},
        trainId: {squash: true, value: null}
    }
};
export const diagToolHistoryState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'users' is a child of 'app'
    name: 'diagtool-history',
    url: '/project/:projectId/admin/diagtool/history',
    component: DiagtoolOverviewComponent,
    params: {
        projectId: {squash: true, value: null},
        trainId: {squash: true, value: null},
        history: true
    }
};


export const DIAGTOOL_STATES = [
    diagToolOverviewState,
    diagToolHistoryState
];
